<template>
  <li v-if="item.has_present">
    <!-- Gift List Section -->
    <div class="ad-section-header">
      <h4>{{ $t("education.Gift_list") }}</h4>
    </div>

    <!-- Info Alert -->
    <div class="ad-gift-alert ad-gift-alert--info">
      <i class="icon-feather-alert-circle"></i>
      <p>{{ $t("education.Gift_text") }}</p>
    </div>

    <!-- Winner Alert -->
    <div v-if="giftList.length && authUserId == giftList[0].id"
         class="ad-gift-alert ad-gift-alert--success">
      <i class="icon-feather-gift"></i>
      <p>
        Listede 1. sıradasın.
        <strong>"{{ giftList[0].gift.name }}"</strong> adlı hediyeyi
        kazanmaya <strong>adaysın!</strong>
      </p>
    </div>

    <!-- Gift Cards -->
    <div class="ad-gift-list">
      <div v-for="(giftItem, gift_list_index) in giftList" :key="'gift_section_' + gift_list_index"
           class="ad-gift-card">
        <div class="ad-gift-rank">{{ gift_list_index + 1 }}</div>
        <div class="ad-gift-image">
          <img :src="giftItem.gift?.image_link" alt="" />
        </div>
        <div class="ad-gift-details">
          <span class="ad-gift-order">{{ $t("education.gift_order") }}</span>
          <span class="ad-gift-name">{{ giftItem.gift?.name }}</span>
          <div v-if="giftItem.user" class="ad-gift-user">
            <img :src="giftItem.user.photo_link" alt="" class="ad-gift-user-avatar" />
            <span class="ad-gift-user-name">{{ giftItem.user.fullname }}</span>
            <span v-if="giftItem.is_finished" class="ad-gift-badge">Kazanan</span>
            <span v-else class="ad-gift-badge">Aday</span>
          </div>
          <div v-else class="ad-gift-no-candidate">
            <span>{{ $t("gift.no_candidates") }}</span>
          </div>
        </div>
      </div>
    </div>

    <!-- All Gifts Button -->
    <button class="ad-btn ad-gift-all-btn" type="button" href="#modal-overflow" uk-toggle>
      <i class="uil-gift"></i> {{ $t("education.All_gift_list") }}
    </button>

    <!-- All Gifts Modal -->
    <div id="modal-overflow" ref="modalRef" uk-modal>
      <div class="uk-modal-dialog">
        <button class="uk-modal-close-default" type="button" uk-close></button>
        <div class="uk-modal-header">
          <h2 class="uk-modal-title">
            {{ $t("education.All_Gift") }}
          </h2>
        </div>
        <div class="uk-modal-body" uk-overflow-auto>
          <div v-for="(giftItem, index) in giftList" :key="'gift_section_modal_' + index"
               class="ad-gift-modal-item">
            <div class="ad-gift-modal-rank">{{ index + 1 }}</div>
            <div v-if="giftItem.gift" class="ad-gift-modal-img">
              <img :src="giftItem.gift.image_link" alt="" />
            </div>
            <div class="ad-gift-modal-info">
              <p v-if="giftItem.user" class="ad-gift-modal-user">
                {{ giftItem.user.fullname }}
              </p>
              <p v-else class="ad-gift-modal-user ad-gift-modal-user--empty">
                {{ $t("gift.no_candidates") }}
              </p>
              <p class="ad-gift-modal-name">{{ giftItem.gift?.name }}</p>
            </div>
            <div v-if="giftItem.user?.fullname" class="ad-gift-modal-action">
              <button class="ad-btn ad-btn--ghost ad-btn--sm" type="button"
                      @click.prevent="$emit('go-link', giftItem.id)">
                <i class="uil-user"></i>
                {{ $t("education.View_Profile") }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Leader Board Section -->
    <template v-if="leaderList && leaderList.length">
      <div class="ad-section-header ad-leader-header">
        <h4>{{ $t("education.Best_table") }}</h4>
      </div>

      <div class="ad-leader-list">
        <div v-for="(leaderItem, index) in leaderList" :key="'leader_section' + index"
             class="ad-leader-item" :class="{ 'ad-leader-item--top': index < 3 }">
          <div class="ad-leader-rank" :class="'ad-leader-rank--' + (index + 1)">
            <template v-if="index === 0">
              <i class="uil-trophy"></i>
            </template>
            <template v-else>
              {{ index + 1 }}
            </template>
          </div>
          <i class="uil-user-circle ad-leader-icon"></i>
          <span class="ad-leader-name">{{ leaderItem.fullname }}</span>
          <span class="ad-leader-points">{{ leaderItem.point.point }} {{ $t("general.point") || 'puan' }}</span>
        </div>
      </div>
    </template>
  </li>
</template>

<script>
export default {
  name: "AssignmentGifts",
  props: {
    item: { type: Object, required: true },
    giftList: { type: Array, default: () => [] },
    leaderList: { type: Array, default: () => [] },
    authUserId: { type: [Number, String], default: null },
  },
  emits: ['go-link'],
};
</script>

<style scoped>
/* Alerts */
.ad-gift-alert {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  padding: 12px 16px;
  border-radius: 8px;
  font-size: 13px;
  margin-bottom: 12px;
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  color: #475569;
}

.ad-gift-alert i {
  font-size: 16px;
  flex-shrink: 0;
  margin-top: 1px;
  color: #64748b;
}

.ad-gift-alert p {
  margin: 0;
  line-height: 1.5;
}

.ad-gift-alert--info {
  background: #f8fafc;
  border-color: #e2e8f0;
  color: #475569;
}

.ad-gift-alert--success {
  background: #f8fafc;
  border-color: #e2e8f0;
  color: #475569;
}

/* Gift List */
.ad-gift-list {
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-bottom: 20px;
}

.ad-gift-card {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 10px 14px;
  background: #f8fafc;
  border-radius: 8px;
  border: 1px solid #e2e8f0;
}

.ad-gift-rank {
  width: 26px;
  height: 26px;
  border-radius: 50%;
  background: #e2e8f0;
  color: #475569;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  font-weight: 700;
  flex-shrink: 0;
}

.ad-gift-image {
  width: 40px;
  height: 40px;
  border-radius: 6px;
  overflow: hidden;
  flex-shrink: 0;
  border: 1px solid #e2e8f0;
  background: #fff;
}

.ad-gift-image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.ad-gift-details {
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.ad-gift-order {
  font-size: 11px;
  color: #94a3b8;
  font-weight: 500;
}

.ad-gift-name {
  font-size: 14px;
  font-weight: 600;
  color: #1e293b;
}

.ad-gift-user {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-top: 2px;
}

.ad-gift-user-avatar {
  width: 20px;
  height: 20px;
  border-radius: 50%;
  object-fit: cover;
  border: 1px solid #e2e8f0;
}

.ad-gift-user-name {
  font-size: 13px;
  color: #475569;
  font-weight: 500;
}

.ad-gift-badge {
  font-size: 11px;
  font-weight: 500;
  padding: 1px 6px;
  border-radius: 4px;
  color: #64748b;
  background: #f1f5f9;
}

.ad-gift-no-candidate {
  font-size: 13px;
  color: #94a3b8;
  font-style: italic;
  margin-top: 2px;
}

/* All Gifts Button */
.ad-gift-all-btn {
  width: 100%;
  margin-bottom: 24px;
  background: #f8fafc;
  color: #475569;
  border: 1px solid #e2e8f0;
}

.ad-gift-all-btn:hover {
  background: #f1f5f9;
  color: #1e293b;
}

/* Modal Items */
.ad-gift-modal-item {
  display: flex;
  align-items: center;
  gap: 14px;
  padding: 14px 0;
  border-bottom: 1px solid #f1f5f9;
}

.ad-gift-modal-item:last-child {
  border-bottom: none;
}

.ad-gift-modal-rank {
  width: 28px;
  height: 28px;
  border-radius: 50%;
  background: #f1f5f9;
  color: #475569;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 13px;
  font-weight: 700;
  flex-shrink: 0;
}

.ad-gift-modal-img {
  width: 44px;
  height: 44px;
  border-radius: 8px;
  overflow: hidden;
  flex-shrink: 0;
}

.ad-gift-modal-img img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.ad-gift-modal-info {
  flex: 1;
  min-width: 0;
}

.ad-gift-modal-user {
  font-size: 14px;
  font-weight: 600;
  color: #1e293b;
  margin: 0 0 2px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.ad-gift-modal-user--empty {
  color: #94a3b8;
  font-weight: 400;
  font-style: italic;
}

.ad-gift-modal-name {
  font-size: 13px;
  color: #64748b;
  margin: 0;
  font-weight: 500;
}

.ad-gift-modal-action {
  flex-shrink: 0;
}

/* Leader Board */
.ad-leader-header {
  margin-top: 8px;
}

.ad-leader-list {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.ad-leader-item {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 10px 14px;
  background: #f8fafc;
  border-radius: 8px;
  border: 1px solid #e2e8f0;
}

.ad-leader-item--top {
  background: #f8fafc;
}

.ad-leader-rank {
  width: 24px;
  height: 24px;
  border-radius: 50%;
  background: #e2e8f0;
  color: #475569;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  font-weight: 700;
  flex-shrink: 0;
}

.ad-leader-rank--1 {
  background: #1e293b;
  color: #fff;
}

.ad-leader-rank--1 i {
  font-size: 12px;
}

.ad-leader-rank--2 {
  background: #475569;
  color: #fff;
}

.ad-leader-rank--3 {
  background: #64748b;
  color: #fff;
}

.ad-leader-icon {
  font-size: 20px;
  color: #94a3b8;
  flex-shrink: 0;
}

.ad-leader-name {
  flex: 1;
  font-size: 13px;
  font-weight: 500;
  color: #1e293b;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.ad-leader-points {
  font-size: 12px;
  font-weight: 600;
  color: #475569;
  background: #f1f5f9;
  padding: 3px 8px;
  border-radius: 4px;
  flex-shrink: 0;
}

/* Responsive */
@media (max-width: 768px) {
  .ad-gift-card {
    padding: 8px 12px;
    gap: 10px;
  }

  .ad-gift-image {
    width: 36px;
    height: 36px;
  }

  .ad-gift-name {
    font-size: 13px;
  }

  .ad-leader-item {
    padding: 8px 12px;
    gap: 8px;
  }
}

@media (max-width: 480px) {
  .ad-gift-user {
    flex-wrap: wrap;
  }

  .ad-gift-modal-action .ad-btn {
    padding: 6px 10px;
    font-size: 12px;
  }
}
</style>
